document.addEventListener("DOMContentLoaded", async () => {
  await import("./table.js");
  await import("./totals.js");
  await import("./form.js");
  await import("./gallery.js");
});
